// extracted by mini-css-extract-plugin
module.exports = {"rating":"vf-z","numberOfStars":"wf-z","count":"xf-z"};